import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Box, Button, TextField } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

// Validation Schema using Yup
const validationSchema = yup.object({
  fromDate: yup.date().required('From date is required'),
  toDate: yup
    .date()
    .required('To date is required')
    .min(yup.ref('fromDate'), 'To date should be after From date'),
});

const DateTimePickerForm = () => {
  const formik = useFormik({
    initialValues: {
      fromDate: null,
      toDate: null,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <form onSubmit={formik.handleSubmit}>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          
         
          <DateTimePicker
            label="From"
            value={formik.values.fromDate}
            onChange={(newValue) => formik.setFieldValue('fromDate', newValue)}
            inputFormat="DD-MM-YYYY hh:mm A"  
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                placeholder="Select start date and time" 
                onFocus={(e) => {
                  e.target.placeholder = '';  
                }}
                onBlur={(e) => {
                  if (!formik.values.fromDate) {
                    e.target.placeholder = 'Select start date and time'; 
                  }
                }}
                InputProps={{
                  ...params.InputProps,
                  notched: true, 
                }}
                error={formik.touched.fromDate && Boolean(formik.errors.fromDate)}
                helperText={formik.touched.fromDate && formik.errors.fromDate}
              />
            )}
          />

          <DateTimePicker
            label="To"
            value={formik.values.toDate}
            onChange={(newValue) => formik.setFieldValue('toDate', newValue)}
            inputFormat="DD-MM-YYYY hh:mm A"  
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                placeholder="Select end date and time" 
                onFocus={(e) => {
                  e.target.placeholder = '';  
                }}
                onBlur={(e) => {
                  if (!formik.values.toDate) {
                    e.target.placeholder = 'Select end date and time'; 
                  }
                }}
                InputProps={{
                  ...params.InputProps,
                  notched: true,  
                }}
                error={formik.touched.toDate && Boolean(formik.errors.toDate)}
                helperText={formik.touched.toDate && formik.errors.toDate}
              />
            )}
          />

        </Box>

        <Box sx={{ mt: 2 }}>
          <Button color="primary" variant="contained" fullWidth type="submit">
            Submit
          </Button>
        </Box>
      </form>
    </LocalizationProvider>
  );
};

export default DateTimePickerForm;
